import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_STOCK_TRANSFER_LIST = 'GET_STOCK_TRANSFER_LIST';

const apiCall = createApiCall(GET_STOCK_TRANSFER_LIST, (params: {}) => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stock-transfers`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
